import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CheckboxSelection from 'components/CheckboxSelection/CheckboxSelection';
import { closeDialogAction } from 'store/actions/dialogsActions';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
import { useHistory } from 'react-router-dom';
import { loadCustomerAction, loadRolesAction } from 'store/actions/appActions';
import { todoCreateOrderScreen } from 'store/actions/dashboardActions';
import Customer from 'types/entities/Customer';
import { setTimeout } from 'timers';

const TodoCreateNewOrder: React.FC = () => {
  const [t] = useTranslation();

  const { dispatch } = useAppState();
  const dialogs = useSelector((state) => state.dialogs);
  const { app } = useSelector((state) => state);
  const history = useHistory();
  const [orderType, setOrderType] = useState('catalog');
  const close = () => {
    dispatch(closeDialogAction('todoCreateOrder'));
  };

  const accepted = () => {
    const previous_customer: string | null = localStorage.getItem('active_customer');
    const customer = app.customers.find((item) => item.name === dialogs.data?.client_name) as Customer;
    const slug = customer?.slug;

    if (JSON.parse(previous_customer || '{}')?.id !== customer?.id) {
      localStorage.setItem('active_customer', JSON.stringify(customer));

      // Dispatch actions
      dispatch(loadCustomerAction(customer));
      dispatch(loadRolesAction());
      localStorage.setItem('navigation_screen', JSON.stringify('customer'));
      dispatch(todoCreateOrderScreen(dialogs.data));

      if (orderType === 'catalog') {
        history.push(`/${slug}/catalogs?create_quote=true`);
      } else {
        history.push(`/${slug}/orders/production/create_order`);
      }
      close();
    } else {
      dispatch(todoCreateOrderScreen(dialogs.data));

      if (orderType === 'catalog') {
        history.push(`/${slug}/catalogs?create_quote=true`);
      } else {
        history.push(`/${slug}/orders/production/create_order`);
      }
      close();
    }
  };

  return (
    <Dialog style={{ maxHeight: 435 }} maxWidth="xs" open={dialogs.todoCreateOrder || false}>
      <DialogTitle>
        <Typography variant="h6" component="span">
          {t('Create_New_Order')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ fontWeight: 500, mb: 1 }}>
          {t('Todo_Create_Order')}
        </Typography>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', marginTop: 5 }}>
          <CheckboxSelection
            label={t('Catalog')}
            checked={orderType === 'catalog'}
            onChange={() => setOrderType('catalog')}
          />
          <CheckboxSelection
            label={t('Time & Material')}
            checked={orderType === 'tm'}
            onChange={() => setOrderType('tm')}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={close}>
          {t('Cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={accepted}>
          {t('Accepted')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TodoCreateNewOrder;
